import { CATEGORIES } from '@/data/categories';

// SEO podaci i adrese stranica za šest područja rada.
// `filter` je ID kategorije fotografija u galeriji (vidi data/gallery.js).
const SERVICE_META = {
  'veliki-formati': {
    slug: 'veliki-formati-outdoor',
    filter: 'V',
    h1: 'Veliki formati i outdoor štampa u Sarajevu',
    metaTitle: 'Veliki formati i outdoor štampa Sarajevo | Garmond Graphic',
    metaDescription:
      'Bilbordi, baneri, fasadne grafike, mesh platna, One Way Vision folije i plakati. Štampa za fasade, izloge i vanjske lokacije — Garmond Graphic, Sarajevo.',
  },
  'brendiranje-prostora': {
    slug: 'brendiranje-prostora-objekata',
    filter: 'P',
    h1: 'Brendiranje poslovnih prostora i objekata u Sarajevu',
    metaTitle: 'Brendiranje prostora i objekata Sarajevo | Garmond Graphic',
    metaDescription:
      'Svjetleća slova, fasadni natpisi, totemi, zidne i podne grafike, press wall i informativne oznake. Brendiranje poslovnog prostora — Garmond Graphic, Sarajevo.',
  },
  'brendiranje-vozila': {
    slug: 'brendiranje-vozila',
    filter: 'A',
    h1: 'Brendiranje vozila u Sarajevu',
    metaTitle: 'Brendiranje vozila Sarajevo | Garmond Graphic',
    metaDescription:
      'Djelimično i kompletno brendiranje automobila, kombija, dostavnih vozila i flote. Vozilo kao pokretna reklama — Garmond Graphic, Sarajevo.',
  },
  tekstil: {
    slug: 'tekstil-radna-odjeca',
    filter: 'T',
    h1: 'Tekstil i radna odjeća s printom u Sarajevu',
    metaTitle: 'Štampa na tekstil i radna odjeća Sarajevo | Garmond Graphic',
    metaDescription:
      'Majice, dukserice, polo majice, sportski dresovi, radna odjeća, jakne, kape i torbe s printom za firme, klubove i događaje — Garmond Graphic, Sarajevo.',
  },
  'event-oprema': {
    slug: 'event-promotivna-oprema',
    filter: 'E',
    h1: 'Event i promotivna oprema u Sarajevu',
    metaTitle: 'Event i promotivna oprema Sarajevo | Garmond Graphic',
    metaDescription:
      'Roll-up sistemi, beach flag zastave, promo pultovi, sajamski štandovi, šatori, zastave i poslovni pokloni za sajmove i događaje — Garmond Graphic, Sarajevo.',
  },
  'posebna-rjesenja': {
    slug: 'posebna-protokolarna-rjesenja',
    filter: 'S',
    h1: 'Posebna i protokolarna rješenja u Sarajevu',
    metaTitle: 'Posebna i protokolarna rješenja Sarajevo | Garmond Graphic',
    metaDescription:
      'Scenografije, informativni panoi, zastave, plakete, medalje i unikatna rješenja za medije, institucije i galerije — Garmond Graphic, Sarajevo.',
  },
};

export const SERVICES = CATEGORIES.map((category) => ({
  ...category,
  ...SERVICE_META[category.id],
  path: `/usluge/${SERVICE_META[category.id].slug}`,
}));

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
